module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 101
// module chunks = 58411574672382 59327539467942 64404980107741